'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.SegmentedRadioButton', ['AVRO.Common.FeatureToggle']).directive('rmSegmentedRadioButton', require('./directives/SegmentedRadioButtonDirective'));